// extracted by mini-css-extract-plugin
module.exports = {"group_container":"InputGroup_group_container__VRxl5","group_label":"InputGroup_group_label__1r_CI"};